export default __webpack_public_path__ + "static/media/tbtc-json-file.a0c7a254.png";